import axios from "axios";
import { refreshAccessToken } from "./refreshTokenService";

// Variable to store the refresh token promise
let isRefreshing = false;
let refreshSubscribers = [];

// Function to add subscribers that will wait for the token to be refreshed
function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

// Function to notify all subscribers about the new token
function onRrefreshed(token) {
  refreshSubscribers.map((cb) => cb(token));
}

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const {
      config,
      response: { status },
    } = error;
    const originalRequest = config;

    if (status === 401 && !originalRequest._retry) {
      if (!isRefreshing) {
        isRefreshing = true;
        originalRequest._retry = true;

        try {
          const newToken = await refreshAccessToken();
          if (newToken) {
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${newToken}`;
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            isRefreshing = false;
            onRrefreshed(newToken);
            refreshSubscribers = [];
            return axios(originalRequest);
          }
        } catch (refreshError) {
          //console.log('refresh fail');
          isRefreshing = false;
          refreshSubscribers = [];
          window.dispatchEvent(new CustomEvent("token-refresh-failed"));
          return Promise.reject(refreshError);
        }
      }

      // Return a new promise that resolves to a retry of the original request
      // for each subscriber when the refresh token call completes
      const retryOrigReq = new Promise((resolve) => {
        subscribeTokenRefresh((token) => {
          originalRequest.headers["Authorization"] = "Bearer " + token;
          resolve(axios(originalRequest));
        });
      });
      return retryOrigReq;
    }
    return Promise.reject(error);
  }
);
